import React from "react";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";
const TopicMenu = ({ topics, selectedKey }) => {
  const styledTopics = [];
  const navigate = useNavigate();
  topics.forEach((topic) =>
    styledTopics.push({
      label: topic.name,
      key: topic.key.toLowerCase(),
      onClick: () => navigate("/" + topic.key.toLowerCase()),
    })
  );

  return (
    <Menu mode="inline" items={styledTopics} selectedKeys={[selectedKey]} />
  );
};
export default TopicMenu;
